export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '恋TA系统'
        },
        children:[
          {
            path: '/',//统计总览
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '恋TA系统-统计总览'
            },
          },{
            path: 'user',//用户管理
            name: 'user',
            component: () => import('@/views/main/user/index'),
            meta: {
              title: '恋TA系统-用户管理'
            },
          },{
            path: 'userDetail',//用户详情
            name: 'userDetail',
            component: () => import('@/views/main/user/detail'),
            meta: {
              title: '恋TA系统-用户详情'
            },
          },{
            path: 'dynamic',//动态管理
            name: 'dynamic',
            component: () => import('@/views/main/dynamic/index'),
            meta: {
              title: '恋TA系统-动态管理'
            },
          },{
            path: 'message1',//聊天列表
            name: 'message1',
            component: () => import('@/views/main/message/index1'),
            meta: {
              title: '恋TA系统-聊天列表'
            },
          },{
            path: 'message2',//会话列表
            name: 'message2',
            component: () => import('@/views/main/message/index2'),
            meta: {
              title: '恋TA系统-会话列表'
            },
          }
          ,{
            path: 'idCar',//实名认证
            name: 'idCar',
            component: () => import('@/views/main/renzheng/idCar'),
            meta: {
              title: '恋TA系统-实名认证'
            },
          }
          ,{
            path: 'education',//学历认证
            name: 'education',
            component: () => import('@/views/main/renzheng/education'),
            meta: {
              title: '恋TA系统-学历认证'
            },
          }
          ,{
            path: 'realEstate',//房产认证
            name: 'realEstate',
            component: () => import('@/views/main/renzheng/realEstate'),
            meta: {
              title: '恋TA系统-房产认证'
            },
          }
          ,{
            path: 'vehicle',//车辆认证
            name: 'vehicle',
            component: () => import('@/views/main/renzheng/vehicle'),
            meta: {
              title: '恋TA系统-车辆认证'
            },
          }
          ,{
            path: 'career',//职业认证
            name: 'career',
            component: () => import('@/views/main/renzheng/career'),
            meta: {
              title: '恋TA系统-职业认证'
            },
          }
          ,{
            path: 'income',//收入认证
            name: 'income',
            component: () => import('@/views/main/renzheng/income'),
            meta: {
              title: '恋TA系统-收入认证'
            },
          }
          ,{
            path: 'fileAudit',//音视频审核
            name: 'fileAudit',
            component: () => import('@/views/main/fileAudit/index'),
            meta: {
              title: '恋TA系统-音视频审核'
            },
          }
          ,{
            path: 'feedback',//用户反馈
            name: 'feedback',
            component: () => import('@/views/main/feedback/index'),
            meta: {
              title: '恋TA系统-用户反馈'
            },
          },{
            path: 'appeal',//用户申诉
            name: 'appeal',
            component: () => import('@/views/main/appeal/index'),
            meta: {
              title: '恋TA系统-用户申诉'
            },
          },{
            path: 'wxPay',//微信支付
            name: 'wxPay',
            component: () => import('@/views/main/pay/wx'),
            meta: {
              title: '恋TA系统-微信支付'
            },
          }
          ,{
            path: 'user1',//未完善信息的用户
            name: 'user1',
            component: () => import('@/views/main/user/index1'),
            meta: {
              title: '恋TA系统-未完善信息列表'
            },
          },{
            path: 'user2',//封禁用户
            name: 'user2',
            component: () => import('@/views/main/user/index2'),
            meta: {
              title: '恋TA系统-封禁用户'
            },
          },{
            path: 'wcxAudit',//小程序管理
            name: 'wcxAudit',
            component: () => import('@/views/main/config/index'),
            meta: {
              title: '恋TA系统-小程序管理'
            },
          }
        ]
          
        
      },

]